var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useRef } from "react";
import { Form as OriginalForm } from "react-bootstrap";
let counter = 0;
// Override the original Form with "Auto ID" so we don't have to manually set it all
// Will still respect the controlId if it's provided, but will generate one if not
const FormGroup = (_a) => {
    var { controlId } = _a, props = __rest(_a, ["controlId"]);
    const autoId = useRef(controlId !== null && controlId !== void 0 ? controlId : `fg-${++counter}`);
    return React.createElement(OriginalForm.Group, Object.assign({ controlId: autoId.current }, props));
};
// Create our Form object that replaces the original with proper typing
const Form = Object.assign(Object.assign({}, OriginalForm), { Group: FormGroup });
// Add all the static properties
Object.setPrototypeOf(Form, OriginalForm);
export default Form;
//# sourceMappingURL=index.js.map